import { FieldComponentType } from "@smart/bridge-intake-components-dom";
import { IconName } from "@smart/itops-sb-design-system-dom";

import { FieldTemplate } from "./types";

export const fieldTemplates: FieldTemplate[] = [
  { type: "mapped" },
  { type: "text" },
  { type: "multilineText" },
  { type: "date" },
  { type: "choice" },
  { type: "checkbox" },
  { type: "currency" },
  { type: "address" },
  { type: "phoneNumber" },
  { type: "email" },
  { type: "file" },
  { type: "info" },
  { type: "number" },
  { type: "group" },
  { type: "appointment" },
  { type: "payment" },
  { type: "signature" },
];

export const fieldComponentGroups: {
  name: string;
  components: FieldTemplate[];
}[] = [
  {
    name: "Structure",
    components: [{ type: "mapped" }, { type: "group" }, { type: "info" }],
  },
  { name: "Choice", components: [{ type: "checkbox" }, { type: "choice" }] },
  {
    name: "Text",
    components: [{ type: "text" }, { type: "multilineText" }],
  },
  {
    name: "Numbers",
    components: [{ type: "number" }, { type: "date" }, { type: "currency" }],
  },
  {
    name: "Contact info",
    components: [
      { type: "contactDetails" },
      { type: "phoneNumber" },
      { type: "address" },
      { type: "email" },
    ],
  },
  {
    name: "Other",
    components: [
      { type: "payment" },
      { type: "appointment" },
      { type: "file" },
      { type: "signature" },
    ],
  },
];

export const fieldComponentIcons: Record<
  FieldComponentType,
  { name: IconName; bgColor: string }
> = {
  mapped: { name: "solidNetworkWired", bgColor: "bg-orange-200" },
  group: { name: "solidObjectGroup", bgColor: "bg-orange-200" },
  info: { name: "solidFileCircleInfo", bgColor: "bg-orange-200" },
  checkbox: { name: "solidList", bgColor: "bg-pink-150" },
  choice: { name: "solidListRadio", bgColor: "bg-pink-150" },
  yesNo: { name: "solidListRadio", bgColor: "bg-cyan-140" },
  text: { name: "solidInputText", bgColor: "bg-blue-60" },
  multilineText: { name: "solidMemo", bgColor: "bg-blue-60" },
  number: { name: "solidHashtag", bgColor: "bg-green-100" },
  date: { name: "solidCalendar", bgColor: "bg-green-100" },
  currency: { name: "solidDollarSign", bgColor: "bg-green-100" },
  phoneNumber: { name: "solidPhone", bgColor: "bg-orange-50" },
  address: { name: "solidLocationDot", bgColor: "bg-orange-50" },
  email: { name: "solidEnvelope", bgColor: "bg-orange-50" },
  payment: { name: "solidCreditCard", bgColor: "bg-yellow-150" },
  appointment: { name: "solidCalendarClock", bgColor: "bg-yellow-150" },
  file: { name: "solidFileArrowUp", bgColor: "bg-yellow-150" },
  signature: { name: "solidSignature", bgColor: "bg-yellow-150" },
  contactDetails: { name: "solidContactCard", bgColor: "bg-orange-50" },
};

export { fieldComponentNames } from "@smart/bridge-intake-components-dom";

export const fieldComponentTooltips: Partial<
  Record<FieldComponentType, { title?: string; text: string }>
> = {
  mapped: {
    title: "Mapped fields",
    text: "This allow answers to be mapped back to the matter in Smokeball",
  },
};

export const fieldComponentContainerDroppableId = "container-field-component";
export const fieldComponentDraggableIdPrefix = "field-component";
export const droppableSeparatorIdPrefix = "droppable-separator";

export const fieldSeparatorDroppableIdRegex = /^droppable-separator\|[0-9]+$/;
export const sectionItemsDroppableId = "droppable-section-items";
export const sectionNavigationDroppableId = "droppable-section-navigation";
export const groupFieldsDroppableIdPrefix = "droppable-group-fields";
export const groupSeparatorDroppableIdRegex =
  /^droppable-separator\|smart:group:[0-9a-zA-Z-]+\|\d+$/;
export const sectionItemContainerDroppablePrefix =
  "droppable-section-item-container";
